"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Point2D = void 0;
/**
 * Represents a 2d point object
 */

var Point2D = /*#__PURE__*/function () {
  function Point2D(arg1, arg2) {
    _classCallCheck(this, Point2D);

    if (typeof arg1 === "number" && typeof arg2 === "number") {
      this.x = arg1;
      this.y = arg2;
    } else if (arg1.x !== undefined && arg1.y !== undefined) {
      this.x = arg1.x;
      this.y = arg1.y;
    }
  }
  /**
   * Creates a new point based on extracting specific properties from any provided object
   * @param data - An `IPoint` object with `x` and `y` numeric properties
   * @returns A new `Point2D` object
   */


  _createClass(Point2D, [{
    key: "move",
    value: function move(arg1, arg2) {
      if (typeof arg1 === "number" && typeof arg2 === "number") {
        this.x = arg1;
        this.y = arg2;
      } else if (arg1.x !== undefined && arg1.y !== undefined) {
        this.x = arg1.x;
        this.y = arg1.y;
      }
    }
    /**
     * Shifts point location to specified delta
     * @param dx - Delta to be added to the `x`-coordinate
     * @param dy - Delta to be added to the `y`-coordinate
     */

  }, {
    key: "shift",
    value: function shift(dx, dy) {
      this.x += dx;
      this.y += dy;
    }
    /**
     * Returns a new point created from bounding this one to the `Rect` object rovided
     * @remarks This method bounds the point to the rect with coordinates `[0, 0] x [r.width, r.height]`.
     * @param r - A bounding box
     * @returns A new `Point2D` object, with coordinates bounded to the box
     */

  }, {
    key: "boundToRect",
    value: function boundToRect(r) {
      return new Point2D(this.x < 0 ? 0 : this.x > r.width ? r.width : this.x, this.y < 0 ? 0 : this.y > r.height ? r.height : this.y);
    }
    /**
     * Calculates the square of the distance between two points
     * @param p - Second point
     * @returns The square of the distance
     */

  }, {
    key: "squareDistanceToPoint",
    value: function squareDistanceToPoint(p) {
      return (this.x - p.x) * (this.x - p.x) + (this.y - p.y) * (this.y - p.y);
    }
    /**
     * Calculates the square of the distance from this point to a line segment
     * @param p1 - The first line segment point
     * @param p2 - The second line segment point
     * @returns The square of the distance
     */

  }, {
    key: "squareDistanceToLine",
    value: function squareDistanceToLine(p1, p2) {
      var lineLength2 = p1.squareDistanceToPoint(p2);
      var dist;

      if (lineLength2 === 0.0) {
        dist = this.squareDistanceToPoint(p1);
      } else {
        var t = ((this.x - p1.x) * (p2.x - p1.x) + (this.y - p1.y) * (p2.y - p1.y)) / lineLength2;
        var k = Math.max(0, Math.min(1, t));
        var p = new Point2D(p1.x + k * (p2.x - p1.x), p1.y + k * (p2.y - p1.y));
        dist = this.squareDistanceToPoint(p);
      }

      return dist;
    }
    /**
     * Creates a copy of this point
     * @returns A new `Point2D` object with copied coordinates
     */

  }, {
    key: "copy",
    value: function copy() {
      return new Point2D(this.x, this.y);
    }
    /**
     * Returns a string representation of the point in the format `"{x, y}"`.
     * @returns A string representation of the point
     */

  }, {
    key: "toString",
    value: function toString() {
      return "{".concat(this.x.toString(), ", ").concat(this.y.toString(), "}");
    }
    /**
     * Returns a JSON representation of the point
     * @returns An `IPoint` object with `x` and `y` numeric properties.
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        x: this.x,
        y: this.y
      };
    }
  }], [{
    key: "BuildFromJSON",
    value: function BuildFromJSON(data) {
      return new Point2D(data.x, data.y);
    }
  }]);

  return Point2D;
}();

exports.Point2D = Point2D;